import { pdfDefaultOptions } from 'ngx-extended-pdf-viewer';

/**
 * Alinha o caminho do sandbox do pdf.js com os assets que o build realmente
 * publica (GESTOR-CLIENT-VA / GESTOR-CLIENT-VB).
 *
 * O `angular.json` copia do ngx-extended-pdf-viewer apenas o glob
 * `*.min.{js,mjs}`. A biblioteca sabe disso para o worker -- em `loadPdfJs()`
 * ela reescreve `workerSrc` para `.min.js` quando `minifiedJSLibraries` está
 * ligado (o default) -- mas NÃO faz o mesmo com `sandboxBundleSrc`, que segue
 * apontando para `assets/pdf.sandbox-<versao>.js`, sem `.min`.
 *
 * Esse arquivo não existe no dist, então o servidor devolve o `index.html` do
 * SPA: o browser tenta executar HTML como script (`SyntaxError: Unexpected
 * token '<'`) e, na sequência, `window.pdfjsSandbox` fica indefinido
 * (`setDocument: "Cannot read properties of undefined (reading
 * 'QuickJSSandbox')"`). Só aparece em PDFs com JavaScript embutido, que são os
 * únicos que fazem o pdf.js carregar o sandbox.
 *
 * A troca é segura porque `loadScript` do pdf.js aceita tanto string quanto
 * função (`"Function" === t.constructor.name && (l = t())`), e o `.min.js`
 * expõe o mesmo `QuickJSSandbox`. Envolver o resolvedor original -- em vez de
 * montar a URL na mão -- preserva a escolha entre a variante ES5 e a moderna.
 *
 * Idempotente: chamar duas vezes não empilha sufixos.
 */
export function usarSandboxMinificadoDoPdfViewer(): void {
  const resolverOriginal = pdfDefaultOptions.sandboxBundleSrc;

  pdfDefaultOptions.sandboxBundleSrc = () => {
    const src = resolverOriginal();
    return src.endsWith('.min.js') ? src : src.replace(/\.js$/, '.min.js');
  };
}
